export default {
  metaInfo: {
    title: "구성원관리"
  },
  created() {
    if (this.$store.getters["auth/tokenPayload"]().type === "member") {
      return this.$router.push("/my/info");
    }
    const { page, perPage, query, approveStatus } = this.$route.query;
    this.handleUpdatePageConfig({ page, perPage, query, approveStatus });
  },
  data() {
    return {
      members: [],
      totalCount: 1,
      config: {
        query: "",
        page: 1,
        perPage: 6,
        approveStatus: "all" // all | pending | approved | refused
      },
      tabStatus: [
        { label: "전체", value: "all" },
        { label: "대기", value: "pending" },
        { label: "승인", value: "approved" },
        { label: "거절", value: "refused" }
      ]
    };
  },
  filters: {
    approvedToKor(status) {
      switch (status) {
        case "pending":
          return "대기";
        case "approved":
          return "승인";
        case "refused":
          return "거절";
      }
    }
  },
  computed: {
    totalPagination() {
      return Math.ceil(this.totalCount / this.config.perPage);
    }
  },

  methods: {
    /**
     * 페이지 Config 값 및 쿼리를 변경하고 API를 호출
     * @param {{query: string, page: number, perPage:number, approveStatus: string}} payload
     * @description handleUpdatePageConfig({page:1}) 이런식으로 사용하면 됩니다.
     */
    handleUpdatePageConfig(payload = {}) {
      this.config = {
        page: Number(payload?.page) || this.config.page,
        perPage: Number(payload?.perPage) || this.config.perPage,
        query: payload?.query || this.config.query,
        approveStatus: payload?.approveStatus || this.config.approveStatus
      };

      this.handleUpdateQuery();
      this.getMembersList();
    },
    /**
     * 라우터 쿼리를 추가하거나 변경
     */
    handleUpdateQuery() {
      this.$router.push({ query: { ...this.config } }).catch(() => {});
    },
    /**
     * 탭 변경시 쿼리 초기화합니다.
     */
    handleChangeTab(approveStatus) {
      this.config = {
        page: 1,
        perPage: 6,
        query: "",
        approveStatus: approveStatus
      };
      this.handleUpdatePageConfig();
    },
    /**
     * 구성원 내역 조회
     */
    async getMembersList() {
      try {
        const result = await this.$store.dispatch(
          "users/biz_manager_member_info",
          {
            page: this.config.page,
            perPage: this.config.perPage,
            q: encodeURI(this.config.query),
            approveStatus: this.config.approveStatus
          }
        );

        this.members = result.members;
        if (result.count === 0) {
          this.totalCount = 1;
        } else {
          this.totalCount = result.count;
        }
      } catch (error) {
        console.error(error);
        return alert("에러가 발생하였습니다");
      }
    },
    async updateMemberApproval(memberId, status) {
      if (!memberId || !status) return;
      try {
        const result = await this.$store.dispatch(
          "users/biz_manager_member_approval",
          {
            _id: memberId,
            status: status
          }
        );
        if (!result.success) return alert("에러가 발생하였습니다");
        this.members = result.members;

        this.totalCount === 0
          ? (this.totalCount = 1)
          : (this.totalCount = result.count);
      } catch (error) {
        console.error(error);
        return alert("에러가 발생하였습니다");
      }
      this.getMembersList();
    },

    pagination(val) {
      const totalPage = this.totalPagination;
      if (val == -1 && this.config.page == 1) {
        alert("첫 번째 페이지 입니다");
        return;
      }

      if (val == 1 && this.config.page == totalPage) {
        alert("마지막 페이지 입니다");
        return;
      }

      this.handleUpdatePageConfig({ page: this.config.page + val });
    }
  }
};
